import Dashboard from "../pages/Dashboard/Dashboard";
import Questions from "../pages/Questions/Questions";
import Forms from "../pages/Forms/Forms";
import AddForms from "../pages/Forms/AddForms";
// import Template from "../pages/Template/Template";
import Chat from "../pages/Chat/ChatContainer";
import AddChannel from "../pages/Channel/AddChannel";
import ProjectManagement from "../pages/ProjectManagement/ProjectManagement";
import AddProjectManagement from "../pages/ProjectManagement/AddProjectManagement";
import ClientManagement from "../pages/ClientManagement/ClientManagement";
import UserManagement from "../pages/UserManagement/UserManagement";
import ServiceRequest from "../pages/ServiceRequest/ServiceRequest";
import Category from "../pages/Category/Category";
import FeedBack from "../pages/Feedback/Feedback";
import Transaction from "../pages/Transaction/Transaction";
import SubmittedForm from "../pages/FeedbackForm/SubmittedForm";
import UnderConstruction from "../components/UnderConstruction/UnderConstruction";
import FeedbackReport from "../pages/Report/FeedbackReport";
import CaseHistory from "../pages/CaseHistory/CaseHistory";
import MonthlyReport from "../pages/MonthlyReport/MonthlyReport";
import ReportCategory from "../pages/reportCategory/ReportCategory";
import CategoryReport from "../pages/categoryReport/ReportCategory";
import HrAndAdminWork from "../pages/HrAndAdminWork/HrAndAdminWork";
import Task from "../pages/Task/Task";
import Email from "../pages/Email/Email";
import HrReports from "../pages/Report/HrReports";
import ItSupportReports from "../pages/Report/ItSupportReports";
import TodoTaskMain from "../pages/TodoTask/TodoTaskMain";
import RecurringTemplateMain from "../pages/RecurringTask/RecurringTemplateMain";
import Ticket from "../pages/Ticket/Ticket";

const Menu = [
  {
    element: HrReports,
    path: "/hrReports",
  },
  {
    element: ItSupportReports,
    path: "/itSupportReports",
  },
  {
    element: Email,
    path: "/email",
  },

  {
    element: CategoryReport,

    path: "/reportCategory",
  },
  {
    element: ReportCategory,
    path: "/",
  },
  {
    element: UnderConstruction,
    path: "/underConstruction",
  },
  {
    element: UserManagement,
    path: "/userManagement",
  },
  {
    element: CaseHistory,
    path: "/caseHistory",
  },
  {
    element: Questions,
    path: "/questions",
  },
  {
    element: Forms,
    path: "/forms",
  },
  {
    element: AddForms,
    path: "/addForms",
  },
  // {
  //   element: Template,
  //   path: "/template",
  // },
  {
    element: Chat,
    path: "/chat",
  },
  {
    element: AddChannel,
    path: "/addChannel",
  },
  {
    element: ProjectManagement,
    path: "/projectManagement",
  },
  {
    element: ClientManagement,
    path: "/clientManagement",
  },
  {
    element: AddProjectManagement,
    path: "/addProjectManagement",
  },
  {
    element: ServiceRequest,
    path: "/serviceRequest",
  },
  {
    element: FeedBack,
    path: "/feedback",
  },
  {
    element: Category,
    path: "/category",
  },
  {
    element: Transaction,
    path: "/transaction",
  },
  {
    element: SubmittedForm,
    path: "/submittedForm",
  },
  {
    element: FeedbackReport,
    path: "/feedbackReport",
  },
  {
    element: MonthlyReport,
    path: "/monthlyReport",
  },
  {
    element: ReportCategory,
    path: "/dashboard",
  },
  {
    element: HrAndAdminWork,
    path: "/hrAndAdminWork",
  },
  {
    element: TodoTaskMain,
    path: "/todo",
  },
  {
    element: Task,
    path: "/task",
  },
  {
    element: Ticket,
    path: "/ticket",
  },
];

export default Menu;